export default ({ bottomButton }) => [
  {
    title: 'Текст', value: bottomButton.contentPosition, paramName: 'contentPosition', parentName: 'bottomButton',
  },
  {
    title: 'Иконка', value: bottomButton.iconPosition, paramName: 'iconPosition', parentName: 'bottomButton', icon: true,
  },
];
